import React, { useState, useEffect, useCallback } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import DateTime from '../DateTime'
import '../../posstyle.scss'
import './header.scss'
import '../../rtlPos.scss'
import { useTranslation } from 'react-i18next'
import { _Apiauth } from '../api/_call'
import { useSelector } from 'react-redux'
import DashboardIcon from '../../../admin/common/icons/sidebar/Dashboard'

const PosHeader = (props) => {
  const { t } = useTranslation()
  const posloc = JSON.parse(localStorage.getItem('pos-loc'))
  const { i18n, Fullhandle } = props
  const [loginData, setLoginData] = useState(null)
  const [LanguageList, setLanguageData] = useState(null)
  const [CurrentLan_flg, setLanguageSelectData] = useState('US.png')
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission)
  const [checkApiCall, setCheckApiCall] = useState(true)
  const posstatics = useSelector((state) => state.app.posstatics)
  const getUserData = async () => {
    setCheckApiCall(false)
    const postdata = {}
    let profileData = await _Apiauth(postdata, `App/profile/get-auth`)
    if (profileData.code === 200) {
      setLoginData(profileData?.data)
      setLanguageData(profileData?.languageList)
    }
  }
  const rtlView = useCallback(
    (type, l) => {
      localStorage.setItem('UserLang', l)
      setLanguageSelectData(localStorage.getItem('UserLang'))
      let bodyid = document.querySelector('#body_id')
      if (type === 'rtl') {
        bodyid.classList.add('rtl')
      } else {
        bodyid.classList.remove('rtl')
      }
    },
    [setLanguageSelectData],
  )
  useEffect(() => {
    const fetchData = async () => {
      if (checkApiCall) {
        await getUserData()
      }

      if (localStorage.getItem('UserLang')) {
        setLanguageSelectData(localStorage.getItem('UserLang'))
      } else {
        setLanguageSelectData('US.png')
      }

      if (localStorage.getItem('UserLang') === 'SA.png') {
        rtlView('rtl', localStorage.getItem('UserLang'))
      }
    }

    fetchData()
  }, [checkApiCall, setLanguageSelectData, rtlView])
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL

  return (
    <>
      <ToastContainer></ToastContainer>
      <div className="main-header">
        <div className="main-header-left-col">
          <div className="main-header-left-col-left">
            <Link to="/app/admin/dashboard" className="main-header-logo">
              <img src={base_assets + 'images/pos/gis-logo.png'} alt="" />
            </Link>
            <ul className="main-header-left-col-left-menu">
              <li className="pos-header-tooltip">
                <div className="main-header-left-col-left-menu-single">
                  <NavLink to="/app/pos/menu" className="d-block">
                    <img
                      src={base_assets + 'images/pos/icons/home-icon.png'}
                      alt=""
                    />
                  </NavLink>
                </div>
                <span className="pos-header-tooltip-text">{t('Home')}</span>
              </li>
              <li className="pos-header-tooltip">
                <div className="main-header-left-col-left-menu-single">
                  <NavLink to="/app/pos/" className="d-block">
                    <img
                      src={base_assets + 'images/pos/icons/shop-icon.png'}
                      alt=""
                    />
                  </NavLink>
                </div>
                <span className="pos-header-tooltip-text">{t('POS')}</span>
              </li>
              <li className="main-header-left-col-left-menu-single main-header-left-col-left-menu-single-country dropdown common-dropdown bg-transparent rounded-0 shadow-none">
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    className="rounded-0 shadow-lg"
                    src={base_assets + 'images/flags/' + CurrentLan_flg}
                    alt="icon"
                  />
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  {LanguageList?.map((LanguageCode, key) => (
                    <li key={key}>
                      {LanguageCode.Lan_value === 'arabic' ? (
                        <Link
                          className="dropdown-item"
                          onClick={() => {
                            i18n.changeLanguage(LanguageCode.Lan_value)
                            rtlView('rtl', LanguageCode.Lan_photo)
                          }}
                        >
                          <img
                            src={
                              base_assets +
                              'images/flags/' +
                              LanguageCode.Lan_photo
                            }
                            alt=""
                          />{' '}
                          <span>{LanguageCode.Lan_text}</span>
                        </Link>
                      ) : (
                        <Link
                          className="dropdown-item"
                          onClick={() => {
                            i18n.changeLanguage(LanguageCode.Lan_value)
                            rtlView('ltr', LanguageCode.Lan_photo)
                          }}
                        >
                          <img
                            src={
                              base_assets +
                              'images/flags/' +
                              LanguageCode.Lan_photo
                            }
                            alt=""
                          />{' '}
                          <span>{LanguageCode.Lan_text}</span>
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </li>
              {parmissiondatashow?.POS?.View ? (
                <li className="main-header-left-col-left-menu-dashboard-plain pos-header-tooltip">
                  <Link
                    to="/app/pos/dashboard"
                    className="main-header-left-col-left-menu-dashboard-plain-link"
                  >
                    <DashboardIcon
                      stroke="currentColor"
                      className="pos-header-dashboard-sidebar-icon"
                    />
                  </Link>
                  <span className="pos-header-tooltip-text">{t('Dashboard')}</span>
                </li>
              ) : null}
            </ul>
          </div>
          <div className="main-header-left-col-right">
            <ul className="main-header-left-col-right-menu"
              onClick={() => localStorage.removeItem("showcheckout")}>
              <li className="pos-header-tooltip">
                <div className="main-header-left-col-right-menu-single hover-effect activee">
                  <Link
                    className="main-header-left-col-right-menu-single-a"
                    to="/app/pos/menu"
                  >
                    <div className="main-header-left-col-right-menu-single-wrap hover-effect-inner ">
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-g menu-icon"
                        src={base_assets + 'images/pos/icons/column-green.png'}
                        alt=""
                      />
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-w menu-icon"
                        src={base_assets + 'images/pos/icons/column-white.png'}
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
                <span className="pos-header-tooltip-text">{t('Menu')}</span>
              </li>
              <li
                className={
                  parmissiondatashow?.POS?.View
                    ? 'pos-header-tooltip'
                    : 'd-none'
                }
              >
                <div className="main-header-left-col-right-menu-single hover-effect">
                  <Link
                    className="main-header-left-col-right-menu-single-a"
                    to="/app/pos/catalog/CollectionList"
                  >
                    <div className="main-header-left-col-right-menu-single-wrap hover-effect-inner ">
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-g cat-icon"
                        src={base_assets + 'images/pos/icons/catalog-green.png'}
                        alt=""
                      />
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-w cat-icon"
                        src={base_assets + 'images/pos/icons/catalog-white.png'}
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
                <span className="pos-header-tooltip-text">{t('Catalog')}</span>
              </li>
              <li
                className={
                  parmissiondatashow?.WishList?.View
                    ? 'pos-header-tooltip'
                    : 'd-none'
                }
              >
                <div className="main-header-left-col-right-menu-single hover-effect">
                  <Link
                    className="main-header-left-col-right-menu-single-a"
                    to="/app/pos/wishlist"
                  >
                    <div className="main-header-left-col-right-menu-single-wrap hover-effect-inner ">
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-g wish-icon"
                        src={base_assets + 'images/pos/icons/heart-green.png'}
                        alt=""
                      />
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-w wish-icon"
                        src={base_assets + 'images/pos/icons/heart-white.png'}
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
                <span className="pos-header-tooltip-text">{t('Wishlist')}</span>
              </li>
              <li
                className={
                  parmissiondatashow?.pos_customer_reports?.View
                    ? 'pos-header-tooltip'
                    : 'd-none'
                }
              >
                <div className="main-header-left-col-right-menu-single hover-effect">
                  <Link
                    className="main-header-left-col-right-menu-single-a"
                    to="/app/pos/customer/customer"
                  >
                    <div className="main-header-left-col-right-menu-single-wrap hover-effect-inner ">
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-g customer-icon"
                        src={base_assets + 'images/pos/icons/customer-green.png'}
                        alt=""
                      />
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-w customer-icon"
                        src={base_assets + 'images/pos/icons/customer-white.png'}
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
                <span className="pos-header-tooltip-text">{t('Customer')}</span>
              </li>
              <li
                className={
                  parmissiondatashow?.cash_register?.View
                    ? 'pos-header-tooltip'
                    : 'd-none'
                }
              >
                <div className="main-header-left-col-right-menu-single hover-effect">
                  <Link
                    className="main-header-left-col-right-menu-single-a"
                    to="/app/pos/Cashregister"
                  >
                    <div className="main-header-left-col-right-menu-single-wrap hover-effect-inner ">
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-g menu-icon"
                        src={
                          base_assets + 'images/pos/icons/cash-register-green.png'
                        }
                        alt=""
                      />
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-w menu-icon"
                        src={
                          base_assets + 'images/pos/icons/cash-register-white.png'
                        }
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
                <span className="pos-header-tooltip-text">{t('Cash Register')}</span>
              </li>
              <li
                className={
                  parmissiondatashow?.pos_reports?.View
                    ? 'pos-header-tooltip'
                    : 'd-none'
                }
              >
                <div className="main-header-left-col-right-menu-single hover-effect">
                  <Link
                    className="main-header-left-col-right-menu-single-a"
                    to="/app/pos/Dailysalereport"
                  >
                    <div className="main-header-left-col-right-menu-single-wrap hover-effect-inner">
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-g report-icon"
                        src={base_assets + 'images/pos/icons/report-green.png'}
                        alt=""
                      />
                      <img
                        className="hover-effect-inner-img hover-effect-inner-img-w report-icon"
                        src={base_assets + 'images/pos/icons/report-white.png'}
                        alt=""
                      />
                    </div>
                  </Link>
                </div>
                <span className="pos-header-tooltip-text">{t('Reports')}</span>
              </li>

              <li className="pos-header-tooltip">
                <div className="main-header-left-col-right-menu-single">
                  {!Fullhandle.active ? (
                    <div className="main-header-left-col-right-menu-single-a" onClick={Fullhandle.enter}>
                      <div className="main-header-left-col-right-menu-single-wrap hover-effect-inner">
                        <svg className='hover-effect-inner-img hover-effect-inner-img-g fullscreen-icon' width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.7407 9.44855L23.4532 2.76054L23.4313 6.55159C23.4243 6.86764 23.6744 7.14262 23.9901 7.13558L24.3904 7.13519C24.706 7.12775 24.967 6.93961 24.9737 6.62356L24.9901 0.97611C24.9901 0.970658 24.9686 0.966355 24.9686 0.960879L24.9994 0.674556C25.0025 0.515749 24.9655 0.374152 24.8633 0.272868C24.7622 0.170777 24.6206 0.108584 24.4633 0.112887L24.1781 0.119536C24.1727 0.119536 24.1684 0.121492 24.1625 0.122299L18.5664 0.0976562C18.2511 0.104697 17.9901 0.365986 17.9831 0.682428L17.9823 1.08377C18.0303 1.45654 18.3225 1.67441 18.6378 1.66737L22.326 1.67715L15.6374 8.34199C15.3327 8.64748 15.3327 9.14267 15.6374 9.44855C15.9421 9.75365 16.4361 9.75365 16.7407 9.44855ZM8.28348 15.7468L1.57106 22.414L1.59252 18.6437C1.59994 18.3272 1.34942 18.0522 1.03417 18.0593L0.609302 18.0601C0.293266 18.0679 0.0326098 18.2556 0.025977 18.5721L0.00958994 24.2195C0.00958994 24.225 0.0310491 24.2285 0.0310491 24.2348L0.000225927 24.5203C-0.00328558 24.6791 0.0337803 24.8215 0.136394 24.922C0.237058 25.0245 0.379078 25.0863 0.535926 25.0824L0.821528 25.0754C0.826966 25.0754 0.830868 25.073 0.837135 25.073L6.45786 25.0977C6.77312 25.0898 7.03377 24.8285 7.04116 24.5125L7.04194 24.1108C6.99398 23.7388 6.70172 23.5201 6.38646 23.5272L2.69823 23.5174L9.38648 16.8533C9.6912 16.5478 9.6912 16.0527 9.38648 15.7472C9.08176 15.4417 8.58818 15.4413 8.28345 15.7468H8.28348ZM24.9905 24.2191L24.9741 18.5716C24.9671 18.2552 24.7061 18.0674 24.3908 18.0596L23.9905 18.0588C23.6749 18.0518 23.4251 18.3271 23.4318 18.6432L23.4536 22.4342L16.7408 15.7467C16.4361 15.4412 15.9421 15.4412 15.6374 15.7467C15.3327 16.0522 15.3327 16.5474 15.6374 16.8529L22.3257 23.5169L18.6378 23.5267C18.3225 23.5197 18.0303 23.7384 17.9823 24.1103L17.9831 24.512C17.9905 24.8285 18.2515 25.0898 18.5664 25.0972L24.163 25.0726C24.1688 25.0726 24.1731 25.0749 24.1786 25.0749L24.4638 25.0819C24.621 25.0858 24.763 25.024 24.8637 24.9216C24.9659 24.8206 25.0026 24.6787 24.9999 24.5199L24.9691 24.2343C24.9691 24.2281 24.9905 24.2246 24.9905 24.2191L24.9905 24.2191ZM2.69826 1.67776L6.3869 1.66806C6.70216 1.6751 6.99439 1.45684 7.04238 1.08443L7.0416 0.682746C7.03377 0.366329 6.77309 0.104624 6.45828 0.0979741L0.837135 0.122225C0.830892 0.121443 0.826991 0.119487 0.821528 0.119487L0.535926 0.112813C0.379103 0.108535 0.236692 0.170728 0.136394 0.272794C0.0337803 0.374103 -0.00326119 0.5157 0.000225927 0.674507L0.0310491 0.96083C0.0310491 0.966282 0.00958994 0.970218 0.00958994 0.976085L0.025977 6.62353C0.033 6.93959 0.293656 7.12773 0.609302 7.13516L1.03419 7.13553C1.34945 7.14257 1.59952 6.86759 1.5925 6.55154L1.57104 2.78123L8.28348 9.44841C8.58781 9.75392 9.08218 9.75392 9.38692 9.44841C9.69167 9.14289 9.69164 8.64733 9.38692 8.34184L2.69826 1.67776Z" fill="#5CC7C1" />
                        </svg>
                      </div>
                    </div>
                  ) : (
                    <div className="main-header-left-col-right-menu-single-a" onClick={Fullhandle.exit}>
                      <div className="main-header-left-col-right-menu-single-wrap hover-effect-inner">
                        <svg className='hover-effect-inner-img hover-effect-inner-img-g fullscreen-icon' width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g>
                            <g id="fullscreen_x5F_exit">
                              <g>
                                <polygon fill="#5CC7C1" points="24.586,27.414 29.172,32 32,29.172 27.414,24.586 32,20 20,20 20,32 			" />
                                <polygon fill="#5CC7C1" points="0,12 12,12 12,0 7.414,4.586 2.875,0.043 0.047,2.871 4.586,7.414 			" />
                                <polygon fill="#5CC7C1" points="0,29.172 2.828,32 7.414,27.414 12,32 12,20 0,20 4.586,24.586 			" />
                                <polygon fill="#5CC7C1" points="20,12 32,12 27.414,7.414 31.961,2.871 29.133,0.043 24.586,4.586 20,0 			" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
                <span className="pos-header-tooltip-text">
                  {Fullhandle.active ? t('Exit Fullscreen') : t('Fullscreen')}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="main-header-right-col">
          <div className="main-header-right-col-inner">
            <div className="main-header-right-col-location">
              <label className="main-header-right-col-location-name">
                {posstatics?.voc ? posstatics?.voc : posloc?.voc}
              </label>
              <div className="main-header-right-col-location-currency">
                <span className="main-header-right-col-location-currency-img">
                  {posstatics?.curr ? (
                    <img
                      src={
                        base_assets +
                        'images/flags/' +
                        posstatics?.curr.toLowerCase() +
                        '.png'
                      }
                      alt=""
                    />
                  ) : (
                    <img
                      src={
                        base_assets +
                        'images/flags/' +
                        posloc?.curr?.toLowerCase() +
                        '.png'
                      }
                      alt=""
                    />
                  )}
                </span>
                <span className="main-header-right-col-location-currency-name">
                  {posstatics?.curr ? posstatics?.curr : posloc?.curr}
                </span>
              </div>
            </div>
            <div className="main-header-right-col-cashier">
              <div className="main-header-right-col-cashier-select common-select">
                <div className="dropdown">
                  <button
                    className="dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      className="main-header-right-col-cashier-select-user"
                      style={{ borderRadius: "50%" }}
                      src={loginData?.myProfile ? loginData?.myProfile : base_assets + 'images/pos/icons/gray-user.png'}
                      alt=""
                    />
                    <span className="main-header-right-user-name">
                      {' '}
                      {loginData?.fname} {loginData?.lname}
                    </span>
                  </button>
                  <ul className="dropdown-menu main-header-right-user-dropdown">
                    {/* {loginData?.userType === "Administrator" ?
                      <li>
                        <div
                          className="dropdown-menu-single"
                          data-bs-toggle="modal"
                          data-bs-target="#dataPurgeModal"
                        >
                          <div className="main-header-right-user-dropdown-img">
                            <i className="fa fa-database" aria-hidden="true"></i>
                          </div>
                          <span>{t('Data Purge')}</span>
                        </div>
                      </li> : ""} */}

                    <li>
                      <Link
                        className="dropdown-menu-single"
                        to="/app/admin/profile"
                      >
                        <div className="main-header-right-user-dropdown-img">
                          <i className="fa fa-user-o" aria-hidden="true"></i>
                        </div>
                        <span>{t('My profile')}</span>
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-menu-single" to="/logout">
                        <div className="main-header-right-user-dropdown-img">
                          <i className="fa fa-power-off" aria-hidden="true"></i>
                        </div>
                        <span>{t('logout')}</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <span className="main-header-right-col-cashier-date">
                {' '}
                <DateTime></DateTime>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PosHeader
